import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    ready: '#2E7B32',
    reject: '#b71c1c',
    primary: '#ff5a10',
    success: "#ff5a10"
  },
})
